export function getFirstName(fullName: string): string {
  return fullName.split(" ")[0]
}

/** Extracts the profession from an `exp` line like "Astrologer · 10 years of practice". */
export function getProfession(exp: string): string {
  return exp.split(" · ")[0]
}
